var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 22 17",
    fill: "none",
    className: "injected-svg",
    "data-src": "/icons/new/menu-youtube.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.82 2.511a2.904 2.904 0 0 0-.654-1.27A2.527 2.527 0 0 0 19.024.5c-1.604-.495-8.03-.495-8.03-.495a56.001 56.001 0 0 0-8.02.47c-.428.139-.82.4-1.142.76a3.016 3.016 0 0 0-.665 1.275 33.916 33.916 0 0 0-.416 5.493c-.01 1.84.128 3.679.416 5.492.117.48.345.916.662 1.27.317.352.712.607 1.145.742 1.626.494 8.02.494 8.02.494a56.132 56.132 0 0 0 8.03-.47c.428-.13.822-.385 1.142-.742a2.9 2.9 0 0 0 .654-1.27c.295-1.81.438-3.65.428-5.493.022-1.851-.121-3.7-.427-5.516v.001ZM8.952 11.426V4.581l5.346 3.423-5.346 3.422Z",
    fill: "#949494"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeLogo);
export default __webpack_public_path__ + "static/media/youtubeLogo.df1f4267d5918d23690879d557d8173f.svg";
export { ForwardRef as ReactComponent };